// src/pages/ProductDetails/InverterDisplayModes.jsx
import React, { useEffect } from 'react';
import './InverterShared.css'; 
import './InverterDisplayModes.css';

const DISPLAY_MODES = [
  {
    id: 'mains_mode',
    title: 'Mains Mode',
    subtitle: 'Utility power is available. Inverter output is OFF.',
    image: 'https://res.cloudinary.com/dhbjxspxa/image/upload/v1779340922/ChatGPT_Image_May_21_2026_at_10_13_29_AM_lhsvwp.png', // Replace with your actual Cloudinary URL
    features: [
      'Displays real-time grid input voltage (e.g., 232v).',
      'Power is intelligently bypassed directly to your appliances.',
      'Battery charges seamlessly in the background.'
    ]
  },
  {
    id: 'ups_off',
    title: 'UPS Mode (Standby)',
    subtitle: 'Main Inverter Output is OFF',
    image: 'https://res.cloudinary.com/dhbjxspxa/image/upload/v1779341001/ChatGPT_Image_May_20_2026_at_08_55_20_PM_klru85.png', // Replace with your actual Cloudinary URL
    features: [
      'Displays current battery voltage (e.g., 13.2v).',
      'Inverter is standing by, ready to switch on instantly.',
      'Zero battery drain while waiting for power requirements.'
    ]
  },
  {
    id: 'ups_on_active',
    title: 'UPS Mode (Active Output)',
    subtitle: 'Main Inverter Output is ON',
    image: 'https://res.cloudinary.com/dhbjxspxa/image/upload/v1779371323/Inverter_main_output_on_beqbvb.png', // Replace with your actual Cloudinary URL
    features: [
      'Displays real-time battery voltage while discharging (e.g., 13.1v).',
      'Inverter is actively powering your connected appliances.',
      'Pure sine wave output ensures silent, safe operation.'
    ]
  },
  {
    id: 'ups_load_display',
    title: 'UPS Mode (Load Display)',
    subtitle: 'Main Inverter Output is ON – Load Display',
    image: 'https://res.cloudinary.com/dhbjxspxa/image/upload/v1779381582/ChatGPT_Image_May_20_2026_at_11_16_09_PM_qyncfa.png', // Replace with your actual Cloudinary URL
    features: [
      'Displays the exact percentage of load currently running (e.g., 000%).',
      'Provides real-time feedback on appliance power draw.',
      'Helps prevent accidental system overload.'
    ]
  },
  {
    id: 'lithium_mode',
    title: 'Lithium Battery Mode (L1)',
    subtitle: 'Inverter is in Lithium Battery Selection Mode',
    image: 'https://res.cloudinary.com/dhbjxspxa/image/upload/v1779381264/ChatGPT_Image_May_21_2026_at_10_12_36_AM_m0uzkk.png', // Replace with your actual Cloudinary URL
    features: [
      'Dedicated charging profile optimized specifically for Lithium cells.',
      'Displays "L1" to confirm correct chemical configuration.',
      'Ensures maximum lifespan and safe charging parameters.'
    ]
  }
];

const InverterDisplayModes = () => {
  
  // Intersection Observer to trigger animations on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          } else {
            // Remove this else block if you only want the animation to happen once
            entry.target.classList.remove("is-visible");
          }
        });
      },
      { threshold: 0.25 } // Triggers when 25% of the row is visible
    );

    const rows = document.querySelectorAll(".scroll-mode-row");
    rows.forEach((row) => observer.observe(row));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="apple-section display-modes-wrapper">
      <div className="display-modes-header">
        <h2 className="apple-title">Intelligent Status Display</h2>
        <p className="apple-subtitle">
          Total control at your fingertips. Know exactly what your system is doing with crystal-clear LCD readouts.
        </p>
      </div>

      <div className="scroll-modes-container">
        {DISPLAY_MODES.map((mode, index) => (
          <div className="scroll-mode-row" key={mode.id}>
            
            {/* LEFT SIDE: Text Description */}
            <div className="mode-text-panel">
              <span className="mode-step-number">0{index + 1}</span>
              <h3 className="mode-title">{mode.title}</h3>
              <p className="mode-subtitle">{mode.subtitle}</p>
              
              <ul className="mode-features-list">
                {mode.features.map((feat, i) => (
                  <li key={i}>
                    <span className="mode-check">✔</span>
                    {feat}
                  </li>
                ))}
              </ul>
            </div>

            {/* RIGHT SIDE: Sliding Image */}
            <div className="mode-image-panel">
              <img
                src={mode.image}
                alt={mode.title}
                className="mode-product-image"
                onError={(e) => (e.target.src = "https://placehold.co/800x600/f5f5f7/333?text=Display+Mode")} 
              />
            </div>
            
          </div>
        ))}
      </div>
    </section>
  );
};

export default InverterDisplayModes;